import { render } from "./RfRegiones.vue?vue&type=template&id=cd07d0a8"
import script from "./RfRegiones.vue?vue&type=script&lang=js"
export * from "./RfRegiones.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__